module.exports = __webpack_public_path__ + "img/hr-puberty-decal-09.20fffee4.png";